import api from "./api";

const importService = {
  parseImportFile: (formData, config) =>
    api.post("/imports/parse", formData, {
      headers: { "Content-Type": "multipart/form-data" },
      ...config,
    }),

  executeImport: (data) => api.post("/imports/execute", data),

  getImportHistory: (params) => api.get("/imports/history", { params }),

  downloadTemplate: (entityType) =>
    api.get(`/imports/template/${entityType}`),

  getParentEntities: (parentType, params) =>
    api.get(`/imports/parent-entities/${parentType}`, { params }),

  getImports: (params) => api.get("/imports", { params }),

  getImportById: (id) => api.get(`/imports/${id}`),

  uploadBulkData: (formData, config) =>
    api.post("/imports/upload", formData, {
      headers: { "Content-Type": "multipart/form-data" },
      ...config,
    }),

  downloadImportFile: (importId) =>
    api.get(`/imports/${importId}/download`, {
      responseType: "blob",
    }),

  retryImport: (importId) => api.post(`/imports/${importId}/retry`),

  cancelImport: (importId) => api.post(`/imports/${importId}/cancel`),

  exportData: (type, params) =>
    api.get(`/exports/${type}`, {
      params,
      responseType: "blob",
    }),

  getImportStatus: (importId) => api.get(`/imports/${importId}/status`),

  getImportErrors: (importId) => api.get(`/imports/${importId}/errors`),

  downloadErrorReport: (importId) =>
    api.get(`/imports/${importId}/errors/download`, {
      responseType: "blob",
    }),
  downloadSuccessReport: (importId) =>
    api.get(`/imports/${importId}/success/download`, {
      responseType: "blob",
    }),
  downloadFullReport: (importId) =>
    api.get(`/imports/${importId}/report/download`, {
      responseType: "blob",
    }),

  importInstitutesFromCSV: (formData, preview = false) =>
    api.post(`/admin/import-institutes-from-csv?preview=${preview}`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    }),

  importSuperadminsFromCSV: (formData, preview = false) =>
    api.post(`/super/admin/import-superadmins-from-csv?preview=${preview}`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    }),

  importDepartmentsFromCSV: (formData, preview = false) =>
    api.post(`/institute/import-csv-departments?preview=${preview}`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    }),

  importTeachersFromCSV: (formData, preview = false) =>
    api.post(`/institute/import-teachers-csv?preview=${preview}`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    }),

  importStudentsFromCSV: (formData, preview = false) =>
    api.post(`/teacher/import-student-csv?preview=${preview}`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    }),

  importCoursesFromCSV: (formData, preview = false) =>
    api.post(`/institute/import-courses-csv?preview=${preview}`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    }),

  importClassesFromCSV: (formData, preview = false) =>
    api.post(`/institute/import-class-csv?preview=${preview}`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    }),

  importSubjectsFromCSV: (formData, preview = false) =>
    api.post(`/institute/import-subjects-csv?preview=${preview}`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    }),

  downloadInstituteTemplate: () =>
    api.get(`/imports/template/institutes`),

  downloadSuperadminTemplate: () =>
    api.get(`/imports/template/superadmins`),
  
  downloadDepartmentTemplate: () =>
    api.post("/institute/download-departments-csv-format", {}, { responseType: "json" }),

  // Allow optional params (instituteId, departmentId, classId, teacherId) so backend can omit fields
  downloadTeacherTemplate: (params = {}) =>
    api.post("/institute/download-teachers-csv-format", params, { responseType: "json" }),

  downloadStudentTemplate: (params = {}) =>
    api.post("/teacher/download-teachers-csv-format", params, { responseType: "json" }),

  downloadClassTemplate: (params = {}) =>
    api.post("/institute/download-class-csv-format", params, { responseType: "json" }),

  downloadCourseTemplate: (params = {}) =>
    api.post("/institute/download-courses-csv-format", params, { responseType: "json" }),

  downloadSubjectTemplate: () =>
    api.post("/institute/download-subjects-csv-format", {}, { responseType: "json" }),

  exportUsersToCSV: (params) =>
    api.post("/users/export-users-csv", {}, { params, responseType: "json" }),

  exportData: (type, params = {}) => {
    const endpoints = {
      departments: "/institute/export-csv-departments",
      teachers: "/institute/export-csv-teachers", 
      students: "/institute/export-csv-students",
      subjects: "/institute/export-csv-subjects",
      classes: "/institute/export-csv-classes",
      courses: "/export/courses-csv",
    };

    const endpoint = endpoints[type];
    if (!endpoint) {
      throw new Error(`Export not supported for entity type: ${type}`);
    }

    return api.post(endpoint, {}, { params });
  },
};

export default importService;
